import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from '../../components/Modal'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Select } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import Loader from '../../components/Loader'
import { getTeacherByGroupId, addGroupUser } from '../../actions/permissions'
import styles from './styles.module.css'

export default function RoleSettingsModal({ data, closeModal }) {
  const dispatch = useDispatch()
  const { teachers, teachers_loading } = useSelector(state => state.roles.permission_groups)

  const [selectedUser, setSelectedUser] = useState('')

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  useEffect(() => {
    data && dispatch(getTeacherByGroupId(data))
  }, [data])

  const handleSubmit = () => {
    selectedUser && dispatch(addGroupUser(data, selectedUser))
    closeModal()
  }

  const renderOptions = ({ fio, mid }) => <option key={mid} value={mid}>{fio}</option>

  return (
    <Modal open={!!data} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsColumn}>
            {teachers_loading ? <Loader /> : (
              <Select label='Преподаватель' onChange={(e) => setSelectedUser(e.target.value)} value={selectedUser}>
                {teachers && [{ mid: "", fio: "Выберите преподавателя" }, ...teachers]?.map(renderOptions)}
              </Select>
            )}
            {selectedUser === '' && <span className={styles.label}>Выберите преподавателя</span>}
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
